<template>
  <el-select 
    class="ASelector inline" 
    v-model="val" 
    size="mini"
    :multiple="multiple"
    @change="change">
    <el-option 
      v-for="item in items" 
      :key="item[valueField]" 
      :label="item[labelField]" 
      :value="item[valueField]" 
    />
  </el-select>
</template>
<script>
import { selector } from "@/common/mixins/selector";

export default {
  name: "ASelector",
  mixins: [selector],  
  props: {
    items: {
      default: [],
    },
    valueField: {
      type: String,
      default: 'id'
    },
    labelField: {
      type: String,
      default: 'name'
    },
    multiple: {
      type: Boolean,
      default: false,
    }
  },  
};
</script>
